import { createContext } from 'react';
const WaveSurferContext = createContext(null);
export default WaveSurferContext;
